import { intersection } from "lib/actions/util";
import { isSetSubsetOfArray } from "lib/actions/util/isSetSubsetOfArray";
import { getFileExtensions } from "./utils";

export const shapefileExtensions = {
  required: new Set(["shp", "dbf", "shx"]),
  optional: new Set([
    "prj",
    "sbn",
    "sbx",
    "fbn",
    "fbx",
    "ain",
    "aih",
    "ixs",
    "mxs",
    "atx",
    "xml",
    "cpg",
    "qix",
    "qmd",
  ]),
};

const shapefileExtensionsAll = [
  ...shapefileExtensions.required,
  ...shapefileExtensions.optional,
];

export const isShapefile = (filenames: string[]) => {
  const exts = getFileExtensions(filenames);
  return intersection(exts, shapefileExtensionsAll).length > 0;
};

export const isCompleteShapefile = (filenames: string[]) =>
  isSetSubsetOfArray(
    shapefileExtensions.required,
    getFileExtensions(filenames),
  );

export const isUnsupportedShapefile = (filenames: string[]) => {
  const exts = getFileExtensions(filenames);
  return intersection(exts, shapefileExtensionsAll).length !== exts.length;
};
